import React from "react"
import SeasonRoundItem from "./SeasonRoundItem";

import {SeasonModel} from "../../features/season/seasonTypes";
import {useFetchRounds} from "../../features/round/roundApi";


type Props = {
    season: SeasonModel;
};

const SeasonRoundList = ({season}: Props) => {
    const {data: rounds} = useFetchRounds(season.id)
    if (!rounds) {
        return <></>
    }

    return (
        <>
            <div>
                {rounds.map((round) => (
                    <SeasonRoundItem key={round.id} round={round}/>
                ))}
            </div>
        </>
    )
}

export default SeasonRoundList;